<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>
          <OLoadingDialog :value="isLoading" />

          <EditMessageDialog ref="editDialog" />

          <v-card>
            <v-toolbar class="card-bar">
              <v-toolbar-title>Audio Messages</v-toolbar-title>
              <v-btn icon class="ml-5" @click="reload">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn color="primary" @click="newRow()">Nova Mensagem...</v-btn>
            </v-toolbar>

            <ODataTable
              :spec="spec"
              :items="rows"
              :disableInitialSort="true"
              @rowClicked="selectRow"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { AudioMessage } from '@/models'
import { brNum } from 'oderon-commons/src/formatters'

let color = 'grey--text text--lighten-1',
  grey = x => ({ html: `<span class="${color}">${x}</span>` })

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    EditMessageDialog: require('./EditMessageDialog').default
  },
  data() {
    return {
      isLoading: false,
      rows: [],
      spec: [
        { t: 'ID|', d: 'id', f: grey, w: 85 },
        { t: 'Nome', d: 'name' },
        { t: 'Tamanho (bytes)|', d: 'size', f: brNum, w: 200 }
      ]
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.rows = await AudioMessage.findAll()
    },

    async newRow() {
      return this.selectRow(null)
    },

    async selectRow(r) {
      let res = await this.$refs.editDialog.open(r && r.id)

      if (res === 'DELETE') {
        this.confirmDelete(r)
      } else if (res != null) {
        this.$loading(async () => {
          // NB: res é um FormData com file incluso
          await AudioMessage.save(res)
          await this.fetchData()
          this.$snack('Salvo com sucesso')
        })
      }
    },

    async confirmDelete(r) {
      let result = await this.$confirm({
        message: `Deseja remover a AudioMessage ${r.name}?`,
        okText: 'Sim, remover',
        cancelText: 'Não, Cancelar'
      })

      if (result) {
        this.$loading(async () => {
          await AudioMessage.delete(r.id)
          await this.fetchData()
          this.$snack('Removido com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
